import { NgModule, LOCALE_ID} from '@angular/core';

import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

import { CommonModule, DatePipe } from '@angular/common';
import { UserRoutingModule } from './user-routing.module';
import { CoreCommonModule } from '@core/common.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgApexchartsModule } from 'ng-apexcharts';

import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { AccountModule } from './account/account.module';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CoreSidebarModule } from '@core/components';
import { NouisliderModule } from 'ng2-nouislider';

import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { registerLocaleData } from '@angular/common';
import { CorePipesModule } from '@core/pipes/pipes.module';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

import { SharedModule } from '../shared/shared.module';
import { ApiTranslatePipe } from '../shared/pipes/api-translate.pipe';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    Ng2FlatpickrModule,
    SharedModule,
    UserRoutingModule,
    SweetAlert2Module.forRoot(),
    CoreCommonModule,
    CorePipesModule,
    NgbModule,
    TranslateModule,
    NgxDatatableModule,
    ContentHeaderModule,
    NgxSkeletonLoaderModule,
    NgApexchartsModule,
    NgSelectModule,
    FormsModule,
    CoreSidebarModule,
    NouisliderModule,
    NgApexchartsModule,
    NgxSkeletonLoaderModule,
    AccountModule
  ],
  providers: [
    ApiTranslatePipe,
    { provide: LOCALE_ID, useValue: 'fr-FR'},
    DatePipe,
  ]
})
export class UserModule { }
